/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADVANCED SECTION - MESSAGE TO END-USERS : STYLES --------------- ++++++++++ */
export default theme => ({
  loadbehindbutton: {
    '& .name-description': {
      width: '100%',
      '& > div:not(.errormessage)': {
        height: '100px'
      }
    },
    '& button': {
      width: 'auto'
    }
  }
});
